module.exports = __webpack_public_path__ + "img/performing-overlay.e168a14.png";